import request from 'api/requests/request';

import {Tag} from 'api/types/tagTypes';
import {TagDTO} from 'api/typesDTO/tagDTO';

import {convertTagDTOArrayToTags} from 'api/converters/tagConverters';

/**
 * Retreives an array of Tag objects (not TagDTO).
 */
export async function getTags(): Promise<Tag[]> {
  const tagDTOArray = (await request('/tag')) as TagDTO[];
  return convertTagDTOArrayToTags(tagDTOArray);
}

/**
 * Sents request to create new tag with
 * provided name. Returns a promise which resolves
 * on successfull addition on the tag.
 * @param tagName name of the tag to be added.
 */
export async function createTag(tagName: string) {
  return await request('/tag', {
    method: 'POST',
    data: {name: tagName},
  });
}

/**
 * Deletes the tag with specified id.
 * @param id ID of the tag to be deleted.
 */
export async function deleteTag(id: string) {
  return await request(`/tag/${id}`, {method: 'DELETE'});
}
